import React from "react";
import {
  Icon,
  Flex,
  Text,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure,
  useColorModeValue,
} from "@chakra-ui/react";
import {
  MdOutlineMoreHoriz,
  MdOutlinePerson,
  MdOutlineCardTravel,
  MdOutlineLightbulb,
  MdDelete,
  MdBlock,
} from "react-icons/md";
import { PROPERTY_STATUS } from "constants/filterDropdownData";
import { useModal } from "contexts/ModalContext";
import { getStatusColor } from "utils/common";
import { USER_REQUIREMENT_ACTIONS } from "constants/defaultState";
import { LEAD_TYPES_TAGS } from "constants/defaultState";

export default function Banner(props) {
  const {
    data,
    onUpdate = () => {},
    currentValue,
    onSelectedAction = () => {},
    onUpdatePropertyStatus = () => {},
    selectedAction,
    handleAddProperty,
    dataType,
    handleExternalModal,
    showInput = false,
    ...rest
  } = props;

  const { openModal } = useModal();

  const textColor = useColorModeValue("secondaryGray.500", "white");
  const textHover = useColorModeValue(
    { color: "secondaryGray.900", bg: "unset" },
    { color: "secondaryGray.500", bg: "unset" }
  );
  const iconColor = useColorModeValue("brand.500", "white");
  const bgList = useColorModeValue("white", "whiteAlpha.100");
  const bgShadow = useColorModeValue(
    "14px 17px 40px 8px rgba(112, 144, 176, 0.15)",
    "unset"
  );
  const bgButton = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const bgHover = useColorModeValue(
    { bg: "secondaryGray.400" },
    { bg: "whiteAlpha.50" }
  );
  const bgFocus = useColorModeValue(
    { bg: "secondaryGray.300" },
    { bg: "whiteAlpha.100" }
  );
  const borderColorOpen = useColorModeValue("blue.500", "blue.300");

  const {
    isOpen: isOpen1,
    onOpen: onOpen1,
    onClose: onClose1,
  } = useDisclosure();

  const getAvailableStatuses = (currentStatus) => {
    if (dataType === "properties") {
      const propertyActions = (() => {
        switch (currentStatus) {
          case "Pending":
            return [
              "Rejected",
              "Active",
              "Edit",
              "Update Listing Score",
              "Expired Notification",
              "Update Expiry",
              "Hard Deleted",
            ];
          case "Inactive":
            return [
              "Active",
              "Edit",
              "Update Listing Score",
              "Expired Notification",
              "Update Expiry",
              "Hard Deleted",
            ];
          case "Active":
            return [
              "Inactive",
              "Edit",
              "Update Listing Score",
              "Share To Social Media",
              "Show Nearby Leads",
              "Expired Notification",
              "Change Lead Automation",
              "Update Expiry",
              "Hard Deleted",
            ];
          case "Expired":
            return [
              "Active",
              "Edit",
              "Update Listing Score",
              "Expired Notification",
              "Update Expiry",
              "Hard Deleted",
            ];
          case "Rejected":
            return [
              "Pending",
              "Edit",
              "Update Listing Score",
              "Expired Notification",
              "Update Expiry",
              "Hard Deleted",
            ];
          case "Deleted":
            return [
              "Active",
              "Edit",
              "Update Listing Score",
              "Expired Notification",
              "Update Expiry",
              "Hard Deleted",
            ];
          default:
            return ["Active"];
        }
      })();
      return [...propertyActions, "Add Comment", "Claim For Owner"];
    } else if (dataType === "Locality") {
      switch (currentStatus) {
        case false:
          return ["Editable", "Delete Price Trend"];
        case true:
          return ["Uneditable", "Delete Price Trend"];
        default:
          return [];
      }
    } else if (dataType === "Plans") {
      switch (currentStatus) {
        case "inactive":
          return ["active", "Edit"];
        case "active":
          return [
            "inactive",
            "Edit",
            "Share",
            "Create Custom Plan",
            "Create Subscription",
          ];
        default:
          return [];
      }
    } else if (dataType === "Feature") {
      return ["Edit"];
    } else if (dataType === "subscriptions") {
      switch (currentStatus) {
        case "active":
          if (selectedAction?.category === "ad") {
            return ["Add Property", "Edit"];
          } else {
            return ["Edit"];
          }
        default:
          return [];
      }
    } else if (dataType === "user_requests") {
      switch (currentStatus) {
        case "Pending":
          return [
            "fulfilled",
            "ignored",
            "deleted",
            "Add Comment",
            "Share To Whatsapp",
          ];
        case "Ignored":
          return ["pending", "Add Comment", "Share To Whatsapp"];
        case "Deleted":
          return ["pending", "Add Comment"];
        default:
          return [
            "pending",
            "ignored",
            "deleted",
            "Add Comment",
            "Share To Whatsapp",
          ];
      }
    } else if (dataType === "users") {
      return [
        "Edit",
        USER_REQUIREMENT_ACTIONS.ADD_REQUIREMENT,
        "Add Comment",
        "Update Classification",
        "Share To Whatsapp",
        "Change Number Visibility",
        "Change Lead Automation",
      ];
    } else if (dataType === "UserReports") {
      return ["Share Report"];
    } else {
      switch (currentStatus) {
        case "Pending":
          return ["Rejected", "Active", "Edit"];
        case "Inactive":
          return ["Active", "Edit"];
        case "Active":
          return ["Inactive", "Edit", "Add Agents"];
        case "Expired":
          return ["Active", "Edit"];
        case "Rejected":
          return ["Pending", "Edit"];
        case "Deleted":
          return ["Active", "Edit"];
        case "Verified":
          return ["Edit", USER_REQUIREMENT_ACTIONS.ADD_REQUIREMENT];
        case "Unverified":
          return ["Edit", USER_REQUIREMENT_ACTIONS.ADD_REQUIREMENT];
        case "Add":
          return [
            USER_REQUIREMENT_ACTIONS.EDIT_REQUIREMENT,
            USER_REQUIREMENT_ACTIONS.SEND_LEAD,
            USER_REQUIREMENT_ACTIONS.VIEW_REQUIREMENT,
            USER_REQUIREMENT_ACTIONS.DELETE_REQUIREMENT,
            "Show Nearby Properties",
          ];
        case LEAD_TYPES_TAGS.shared:
          return [
            USER_REQUIREMENT_ACTIONS.EDIT_REQUIREMENT,
            USER_REQUIREMENT_ACTIONS.SEND_LEAD,
            USER_REQUIREMENT_ACTIONS.VIEW_REQUIREMENT,
            "Show Nearby Properties",
          ];
        case "Update":
          return ["Edit"];
        default:
          return [];
      }
    }
  };
  const handleMenuClick = () => {
    onOpen1();
    onSelectedAction();
  };

  const handleMenuItemClick = (
    selectedStatus,
    customListingScore,
    postToSocialMedia,
    comment
  ) => {
    const updatedPropertyType =
      PROPERTY_STATUS.find((item) => item.label === selectedStatus)?.value ??
      null;

    onUpdatePropertyStatus({
      updatedPropertyType,
      type: selectedAction.collection_type,
      slug: selectedAction.slug_url,
      id: selectedAction._id,
      status: selectedStatus,
      custom_listing_score: customListingScore,
      postToSocialMedia: postToSocialMedia || false,
      comment,
    });
  };

  const statusIcons = {
    Rejected: MdBlock,
    Active: MdOutlineCardTravel,
    Inactive: MdOutlinePerson,
    Pending: MdOutlineLightbulb,
    Delete: MdDelete,
  };
  const handleMenuItemClickModalOpen = (selectedStatus) => {
    // "Add Comment" always uses MainMenu's own input modal flow,
    // never the page's external modal handler
    if (
      handleExternalModal &&
      dataType === "properties" &&
      selectedStatus !== "Add Comment"
    ) {
      handleExternalModal(selectedStatus, selectedAction?._id, selectedAction);
      return;
    }

    if (selectedStatus === "Show Nearby Properties") {
      onUpdatePropertyStatus({
        status: selectedStatus,
        id: selectedAction?._id,
      });
      return;
    }

    if (selectedStatus === "Add Agents") {
      onUpdatePropertyStatus({
        status: selectedStatus,
        id: selectedAction?._id,
      });
      return;
    }

    if (selectedStatus === "Delete Price Trend") {
      onUpdatePropertyStatus({
        status: selectedStatus,
        id: selectedAction?._id,
      });
      return;
    }

    const isDeleteRequirement =
      selectedStatus === USER_REQUIREMENT_ACTIONS.DELETE_REQUIREMENT;
    const modalConfig = {
      title: `${isDeleteRequirement ? "Delete Requirement" : "Update Status"}`,
      bodyText:
        dataType !== "Locality"
          ? `Are you sure you want ${
              isDeleteRequirement ? "" : "to update status"
            } to
      <span style="font-weight: bold;">${selectedStatus}</span>
    ? `
          : `Are you sure you want to make it <span style="font-weight: bold;">${
              selectedStatus !== "Active" ? "uneditable?" : "editable?"
            }</span>`,
      actions: [
        {
          label: isDeleteRequirement ? "Yes, Delete" : `Yes, Update`,
          colorScheme: getStatusColor(selectedStatus).colorScheme || "blue",
          onClick: (comment, _, listingScore, postToSocialMedia) => {
            handleMenuItemClick(
              selectedStatus,
              listingScore,
              postToSocialMedia,
              comment
            );
          },
        },
      ],
    };
    if (selectedStatus === "Update Listing Score") {
      modalConfig.title = "Update Listing score:";
      modalConfig.bodyText = "";
    }
    if (selectedStatus === "Update Classification") {
      modalConfig.title = "Update Classification";
      modalConfig.bodyText = "Are you sure you want to update classification?";
      modalConfig.showInputBox = false;
      openModal(modalConfig);
      return;
    }
    if (
      (selectedStatus === "Active" ||
        selectedStatus === "Update Listing Score") &&
      dataType === "properties"
    ) {
      modalConfig.customListingScore = selectedAction?.custom_listing_score;
      modalConfig.showListingScoreInput = true;
      if (selectedStatus === "Active") {
        modalConfig.showSocialMediaCheckbox = true;
      }
    }
    if (dataType === "subscriptions" && selectedStatus === "Edit") {
      onUpdatePropertyStatus({
        status: selectedStatus,
        subscription_id: selectedAction._id,
      });
      return;
    }
    if (dataType === "Plans" && selectedStatus === "Edit") {
      const updatedPropertyType = "/admin/plans";
      onUpdatePropertyStatus({
        updatedPropertyType,
        id: selectedAction._id,
      });
      return;
    }
    if (selectedStatus === "Share To Whatsapp") {
      onUpdatePropertyStatus({
        updatedPropertyType: "Share To Whatsapp",
      });
      return;
    }
    if (selectedStatus === "Change Number Visibility") {
      onUpdatePropertyStatus({
        updatedPropertyType: "Change Number Visibility",
        id: selectedAction._id,
      });
      return;
    }
    if (selectedStatus === "Change Lead Automation") {
      onUpdatePropertyStatus({
        updatedPropertyType: "Change Lead Automation",
        id: selectedAction._id,
      });
      return;
    }
    if (dataType === "Plans" && selectedStatus === "Create Custom Plan") {
      onUpdatePropertyStatus({
        updatedPropertyType: selectedStatus,
        id: selectedAction._id,
      });
      return;
    }

    if (selectedStatus === "Create Subscription") {
      onUpdatePropertyStatus({
        updatedPropertyType: selectedStatus,
        id: selectedAction._id,
        selectedData: selectedAction,
      });
      return;
    }

    if (dataType === "UserReports") {
      onUpdatePropertyStatus({
        updatedPropertyType: "Share Report",
        reportData: selectedAction,
      });
      return;
    }
    if (dataType === "Plans" && selectedStatus === "Share") {
      const updatedPropertyType = "Share";
      onUpdatePropertyStatus({
        updatedPropertyType,
        id: selectedAction._id,
      });
      return;
    }
    if (dataType === "Feature" && selectedStatus === "Edit") {
      const updatedPropertyType = "/admin/Feature";
      onUpdatePropertyStatus({
        updatedPropertyType,
        id: selectedAction._id,
      });
      return;
    }
    if (selectedStatus === "Edit") {
      const updatedPropertyType = "/admin/form";
      onUpdatePropertyStatus({
        updatedPropertyType,
        type: selectedAction.collection_type,
        slug: selectedAction.slug_url,
        id: selectedAction._id,
      });
      return;
    }
    if (
      selectedStatus === "Add" ||
      selectedStatus === USER_REQUIREMENT_ACTIONS.SEND_LEAD
    ) {
      onUpdatePropertyStatus({
        id: selectedAction._id,
        status: selectedStatus,
      });
      return;
    }
    if (selectedStatus === "Update Expiry") {
      onUpdatePropertyStatus({
        updatedPropertyType: selectedStatus,
        id: selectedAction._id,
      });
      return;
    }
    if (
      [
        USER_REQUIREMENT_ACTIONS.ADD_REQUIREMENT,
        USER_REQUIREMENT_ACTIONS.EDIT_REQUIREMENT,
        USER_REQUIREMENT_ACTIONS.VIEW_REQUIREMENT,
      ].includes(selectedStatus)
    ) {
      onUpdatePropertyStatus({
        updatedPropertyType:
          selectedStatus === USER_REQUIREMENT_ACTIONS.VIEW_REQUIREMENT
            ? USER_REQUIREMENT_ACTIONS.VIEW_REQUIREMENT
            : USER_REQUIREMENT_ACTIONS.ADD_REQUIREMENT,
        id: selectedAction._id,
        status: selectedStatus,
      });
      return;
    }
    if (selectedStatus === "Add Property") {
      handleAddProperty(selectedAction?.user_phone, selectedAction?._id);
      return;
    }
    if (showInput) {
      modalConfig.showInputBox = showInput;
      modalConfig.comment =
        selectedAction?.comment === "-" ? "" : selectedAction?.comment;
    }
    openModal(modalConfig);
  };

  return (
    <Menu isOpen={isOpen1} onClose={onClose1} placement="right-start">
      <MenuButton
        align="center"
        justifyContent="center"
        bg={bgButton}
        _hover={bgHover}
        _focus={bgFocus}
        _active={bgFocus}
        w="37px"
        h="37px"
        lineHeight="100%"
        onClick={handleMenuClick}
        borderRadius="10px"
        border={isOpen1 ? `2px solid ${borderColorOpen}` : "none"}
      >
        <Icon as={MdOutlineMoreHoriz} color={iconColor} w="24px" h="24px" />
      </MenuButton>
      <MenuList
        w="170px"
        minW="unset"
        maxW="170px !important"
        border="transparent"
        backdropFilter="blur(63px)"
        bg={bgList}
        boxShadow={bgShadow}
        borderRadius="10px"
        p="10px"
        mr="10px"
        style={{ zIndex: 5 }}
      >
        {getAvailableStatuses(currentValue)
          ?.filter((item) => item !== currentValue)
          ?.map((item, index) => (
            <MenuItem
              key={item}
              fontSize={"md"}
              transition="0.2s linear"
              color={textColor}
              _hover={textHover}
              p="0px"
              borderRadius="8px"
              _active={{ bg: "transparent" }}
              _focus={{ bg: "transparent" }}
              mt={index !== 0 ? "8px" : "0px"}
              onClick={() => handleMenuItemClickModalOpen(item)}
            >
              <Flex align="center">
                <Icon as={statusIcons[item]} h="16px" w="16px" me="8px" />
                <Text fontSize="sm" fontWeight="400">
                  {item}
                </Text>
              </Flex>
            </MenuItem>
          ))}
      </MenuList>
    </Menu>
  );
}
